import styled from "styled-components";

export const Column = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};

  @media (max-width: 520px) {
    width: 100%;
  }
`;

export const InputFlex = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small};
  width: 350px;

  @media (max-width: 520px) {
    width: 100%;
  }
`;
